<template>
    <div class="col-12 nopads  list-container">
      <div v-if="stations.length > 0" class="col-sm-12 list-content result-table">
          <vue3-datatable
              ref="resultTable"
              :rows="stations"
              :columns="fields"
              :pagination="false"
              :sticky-header="true"
              height="47.5em"
              :sortable="true"
              skin="bh-table-compact"
              row-class="routa-table-row"
              cell-class="routa-table-cell"
              @row-click="editItem"
          >
              <template #station_scales="row">
                <span v-if="row.value.station_scales && row.value.station_scales.length > 0">
                  {{ $t('common.yes') }}
                </span>
                      <span v-else>
                  {{ $t('common.no') }}
                </span>
              </template>
              <template #station_materials="row">
                  <div
                      v-for="result of row.value.station_materials"
                      :key="result.id"
                  >
                      {{ result.material.name }}
                  </div>
              </template>

          </vue3-datatable>
      </div>
    </div>
</template>

<script>
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'MaterialStationList',
    components: {Vue3Datatable},
    props: {
        stations: {
            type: Array,
            default: function () {
                return []
            }
        },
    },
    data: function () {
        return {
            fields: [
                {field: 'id', title: this.$t('common.id'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'name', title: this.$t('material_station.name'), sort: true, headerClass: 'routa-table-header'},
                {field: 'station_scales', title: this.$t('material_station.scales'), sort: true, headerClass: 'routa-table-header'},
                {field: 'station_materials', title: this.$t('material_station.materials'), sort: true, headerClass: 'routa-table-header'}
            ]
        }
    },
    methods: {
        editItem: function (station) {
            let r = this.stations.find(item => item.id === station.id)
            if (r) {
                this.$emit('rowClicked', r)
            }
        }
    }
}
</script>
